<template>
  <div class="pc-expand" v-html="webinarInfo.customPage"></div>
</template>

<script>
import { $subscriber } from "fire-wind-water";
export default {
  name: "Expand",
  data() {
    return {
      webinarInfo: {}
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      $subscriber.subscribe("webinarInfo", data => {
        this.webinarInfo = data;
      });
    }
  }
};
</script>

<style scoped></style>
